import * as Vue from 'vue';
import * as VueWeb from './adapter-vue-web';

let vue: any;

if (window && !(window as any).uni) {
  vue = { ...VueWeb, ...(VueWeb as any).vue };
}

export default vue as typeof Vue;
